module.exports = __webpack_public_path__ + "media/images/like/heart-184cb2f1cc8641fcc9e9c4e03874d4ce.svg";